export const BRAND = {
  name: "REVIVE",
  subname: "PRO DETAILING",
  phone: "0412 383 817",
  phoneRaw: "0412383817",
  email: "bookings@reviveprodetailing.com.au",
  area: "Sydney & Surrounds",
  hours: "Mon–Sat · 7:00 AM — 6:00 PM",
  logoUrl: "https://customer-assets.emergentagent.com/job_7ced90bf-7d18-41de-911b-ec7cfeab1c57/artifacts/ac84eqmb_IMG_8886.jpeg",
  socials: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    tiktok: "https://tiktok.com",
  },
};

export const SERVICES = [
  {
    id: "exterior-wash",
    title: "Exterior Wash & Wax",
    short: "Hand wash · iron decon · premium wax",
    price: "from $90",
    duration: "2 hrs",
    description:
      "Two-bucket hand wash, iron-fallout decontamination, clay-bar treatment, and a premium wax seal that leaves a deep wet-look shine.",
  },
  {
    id: "interior-detail",
    title: "Interior Detailing",
    short: "Shampoo · steam · leather conditioning",
    price: "from $200",
    duration: "3 hrs",
    description:
      "Full vacuum, steam extraction on carpets and seats, dashboard and trim conditioning, leather feed & seal, glass crystal-clear.",
  },
  {
    id: "full-detail",
    title: "Full Detailing",
    short: "Inside & out · the complete reset",
    price: "from $350",
    duration: "4–5 hrs",
    description:
      "The complete reset — exterior hand wash, decon, premium wax, interior steam clean, leather feed, dash & trim conditioning, tyres dressed. The whole car, sorted.",
  },
  {
    id: "paint-correction",
    title: "Paint Correction · 3-Stage",
    short: "Cut · polish · finish — swirl-free clarity",
    price: "from $650",
    duration: "1–2 days",
    description:
      "A full three-stage machine correction — heavy cut, refining polish, and a final jewelling stage — to remove swirls, holograms and scratches, then bring the paint to glass-like clarity.",
  },
  {
    id: "ceramic-coating",
    title: "Ceramic Coating",
    short: "9H hardness · up to 5-year protection",
    price: "from $1,200",
    duration: "1–2 days",
    description:
      "Professional-grade nano-ceramic coating bonded to the paint for hydrophobic protection, chemical resistance, and a glass-like gloss.",
  },
  {
    id: "ppf",
    title: "Paint Protection Film (PPF)",
    short: "Clear self-healing armour for your paint",
    price: "Quote on enquiry",
    duration: "1–3 days",
    description:
      "Premium self-healing PPF applied to high-impact zones or full body — invisible protection against stone chips, scratches and road rash. Custom-cut to your vehicle.",
  },
  {
    id: "colored-ppf",
    title: "Coloured PPF",
    short: "Change the look · keep the factory paint",
    price: "Quote on enquiry",
    duration: "2–4 days",
    description:
      "Coloured and satin-finish PPF — change the look of your car without touching the OEM paint. Removable, factory-safe, and protects underneath.",
  },
  {
    id: "wrapping",
    title: "Vinyl Wrapping",
    short: "Full or partial · gloss / satin / matte / chrome",
    price: "Quote on enquiry",
    duration: "2–4 days",
    description:
      "Full-body or feature-panel vinyl wraps in any finish — gloss, satin, matte, chrome, brushed metal, carbon. Personalised quote once we know your goal.",
  },
  {
    id: "headlight-restore",
    title: "Headlight Restoration",
    short: "Cut · polish · UV seal",
    price: "from $120",
    duration: "1 hr",
    description:
      "Sand, cut, and polish foggy oxidised headlights, then seal with a UV protectant to restore clarity and night-time visibility.",
  },
  {
    id: "engine-bay",
    title: "Engine Bay Detail",
    short: "Degrease · dress · protect",
    price: "from $90",
    duration: "1 hr",
    description:
      "Safe degrease of engine bay, plastics dressed, metals polished — your bonnet pops every time you open it.",
  },
];

export const PACKAGES = [
  {
    id: "bronze",
    name: "Bronze",
    tagline: "The Weekly",
    price: "$120",
    items: ["Hand wash & dry", "Wheels & tyres", "Windows in-out", "Interior vacuum", "Dash & trim wipe"],
  },
  {
    id: "silver",
    name: "Silver",
    tagline: "The Refresh",
    price: "$240",
    items: ["Bronze package", "Iron decon + clay", "Premium wax", "Leather clean & condition", "Carpet shampoo"],
    featured: true,
  },
  {
    id: "gold",
    name: "Gold",
    tagline: "The Showroom",
    price: "$550",
    items: ["Silver package", "3-stage paint correction", "6-month sealant", "Engine bay detail", "Headlight polish"],
  },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1601362840469-51e4d8d58785?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1542362567-b07e54358753?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1583121274602-3e2820c69888?auto=format&fit=crop&w=1200&q=80",
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1669235219155-30c21a197eba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXIlMjBkZXRhaWxpbmclMjBibGFjayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc4NTkxMjA4fDA&ixlib=rb-4.1.0&q=85";

export const SERVICE_IMAGES = {
  ceramic:
    "https://images.unsplash.com/photo-1608382247609-7078eb3f9108?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxjYXIlMjBjZXJhbWljJTIwY29hdGluZyUyMHdhdGVyJTIwZHJvcHMlMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc3ODU5MTIwOHww&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.unsplash.com/photo-1775848366579-3178bc69115c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnRlcmlvciUyMGNsZWFuaW5nJTIwbHV4dXJ5JTIwbGVhdGhlcnxlbnwwfHx8fDE3Nzg1OTEyMDh8MA&ixlib=rb-4.1.0&q=85",
};
